import { PaginationParams } from 'models/pagination';
import { AuditUser } from 'services/user/user.model';

export enum TemplateStatus {
	DRAFT = 'DRAFT',
	TESTING = 'TESTING',
	PUBLISHED = 'PUBLISHED',
	ARCHIVED = 'ARCHIVED',
}

export interface TemplateNamedRef {
	id: string;
	name: string;
}

export interface TemplateVersionSummary {
	id: string;
	version: number;
	status: TemplateStatus;
	description: string | null;
	updatedAt: string;
}

export interface TemplateHistoricEntry {
	id: string;
	version: number;
	status: TemplateStatus;
	description: string | null;
	createdAt: string;
	createdBy: AuditUser | null;
	updatedAt: string;
}

export interface SchemaItem {
	name: string;
	description: string;
	input_schema: Record<string, unknown>;
}

export interface SetupTemplate {
	id: string;
	templateKey: string;
	productCatalog: TemplateNamedRef;
	vertical: TemplateNamedRef;
	branch: TemplateNamedRef | null;
	published: TemplateVersionSummary | null;
	inDrafting: TemplateVersionSummary | null;
	inTesting: TemplateVersionSummary | null;
	inArchived: TemplateVersionSummary | null;
	updatedAt: string;
}

export interface SetupTemplateDetail {
	id: string;
	productCatalogId: string;
	verticalId: string;
	branchId: string | null;
	description: string | null;
	promptMaster: string;
	promptUser: string;
	schema: SchemaItem[];
	version: number;
	status: TemplateStatus;
	publishedAt: string | null;
	archivedAt: string | null;
	createdAt: string;
	createdBy: AuditUser | null;
	updatedAt: string;
	updatedBy: AuditUser | null;
	deletedAt: string | null;
	deletedBy: AuditUser | null;
	productCatalog: TemplateNamedRef;
	vertical: TemplateNamedRef;
	branch: TemplateNamedRef | null;
	historic: TemplateHistoricEntry[];
}

export interface SetupTemplateListParams extends PaginationParams {
	productCatalogId?: string;
	verticalId?: string;
	branchId?: string;
	search?: string;
	global?: boolean;
}

export interface CreateSetupTemplateDTO {
	productCatalogId: string;
	verticalId: string;
	branchId?: string;
	description?: string;
	promptMaster: string;
	promptUser: string;
	schema?: SchemaItem[];
}

export interface UpdateSetupTemplateDTO {
	description?: string;
	promptMaster?: string;
	promptUser?: string;
	schema?: SchemaItem[];
}

export interface ProblemDetail {
	type?: string;
	title?: string;
	status?: number;
	detail?: string;
	instance?: string;
}

export type StatusBadgeColor = 'neutral' | 'warning' | 'success' | 'error';
